var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiw4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6099 44.2735L49.9356 48.9606C51.2648 51.6396 54.3378 52.9627 57.1975 52.0873L58.0315 51.832C58.8019 51.5962 59.4706 51.1082 59.9301 50.4465V50.4465C60.6013 49.48 61.7033 48.9036 62.8799 48.9036H63.2255C64.9054 48.9036 66.4277 49.8926 67.1105 51.4274L69.1754 56.0691C70.0638 58.0661 71.9631 59.4261 74.1398 59.6239L74.5923 59.665C76.8996 59.8746 79.0835 58.5885 80.0191 56.469V56.469C81.1186 53.9783 83.9008 52.6962 86.5086 53.4785L87.5054 53.7776C91.08 54.8499 94.8296 52.7364 95.7631 49.1231L96.2614 47.194M36.7114 65.9281L43.7057 75.1119C44.498 76.1523 45.4634 77.0486 46.5597 77.7617L48.4875 79.0158C50.8004 80.5203 52.1057 83.1688 51.89 85.9194V85.9194C51.7482 87.7272 50.9591 89.4231 49.6676 90.6958L46.7551 93.5661M92.9847 94.7771L91.8722 92.5314C90.2698 89.2968 91.0998 85.3851 93.8777 83.08V83.08C95.1489 82.0252 96.0518 80.5935 96.456 78.9918L96.6183 78.3486C97.3392 75.4918 99.3046 73.1095 101.972 71.859L104.596 70.6294M105.373 69.3358C105.373 88.5323 89.8107 104.094 70.6143 104.094C51.4178 104.094 35.856 88.5323 35.856 69.3358C35.856 50.1393 51.4178 34.5775 70.6143 34.5775C89.8107 34.5775 105.373 50.1393 105.373 69.3358Z",
    stroke: "#008CB7",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3378 38.6447C43.6767 31.3474 35.1891 28.2367 32.1223 31.2765C26.896 36.4567 39.3913 57.5368 60.0312 78.3602C80.6711 99.1836 101.64 111.865 106.866 106.685C109.155 104.416 108.045 99.0978 104.34 92.0871M104.34 92.0871L102.283 98.62M104.34 92.0871L110.766 94.8649",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3924 84.3726C32.0205 94.9822 28.8503 103.448 31.8685 106.536C35.9023 110.663 49.7913 103.959 65.7103 90.9897M93.1839 34.7462C100.22 31.0908 105.546 30.018 107.799 32.3226C112.942 37.5851 100.114 58.4643 79.1468 78.9578C77.4231 80.6425 75.698 82.2721 73.9807 83.8415M93.1839 34.7462L99.7023 36.8486M93.1839 34.7462L96.0067 28.3403",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiw4);
export default __webpack_public_path__ + "static/media/hiw-4.867a49c2821e12f162206b7e1dc70aa0.svg";
export { ForwardRef as ReactComponent };